import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/${dossierId}/InsuranceCarrierComponent`, method: 'GET', token: token })
}
